import { Component } from '@angular/core';

import { HeroComponent } from './components/hero/hero.component';
import { IntroComponent } from './components/intro/intro.component';
import { WhyNowComponent } from './components/why-now/why-now.component';
import { ExecutiveSummaryComponent } from './components/executive-summary/executive-summary.component';
import { CharterComponent } from './components/charter/charter.component';
import { PlatformCoverageComponent } from './components/platform-coverage/platform-coverage.component';
import { HereToHelpComponent } from './components/here-to-help/here-to-help.component';
@Component({
  selector: 'app-gcc',
  standalone: true,
  imports: [
    HeroComponent,
    IntroComponent,
    WhyNowComponent,
    ExecutiveSummaryComponent,
    CharterComponent,
    PlatformCoverageComponent,
    HereToHelpComponent
  ],
  templateUrl: './gcc.component.html'
})
export class GccComponent {}